export default __webpack_public_path__ + "static/media/profile-B-1_LS.6a416150.png";